import "core-js/modules/es.array.push.js";
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import dayjs from 'dayjs';
export default {
  props: ['isClose'],
  emits: ['change'],
  setup(props, {
    emit
  }) {
    let time = ref(null);
    const router = useRouter();
    const change = () => {
      emit('change');
    };
    onMounted(() => {
      time.value = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
    });
    const logout = () => {
      router.push('/login');
    };
    return {
      change,
      time,
      logout
    };
  }
};